import ReportEditScreen from './ReportEditScreen';

export default ReportEditScreen;
